import React from 'react'

const Shape = (props) => (
  <div
    className={`ui gp-shape shape-${props.group} ${props.className}`}
    style={props.style}
    {...props.events}
  >
    {props.children}
  </div>
)

Shape.defaultProps = {
  group: '',
  className: '',
  style: {},
  events: []
}

export default Shape
